import { lazyLoad } from 'router/suspense';

import VerifyEmailPage from '../pages/auth/email/EmailPage';
import ErrorPage from '../pages/private/404/404';
import ApplicationPage from '../pages/private/application/ApplicationPage';
import BacktestsPage from '../pages/private/backtests/BacktestsPage';
import CandleValidationsPage from '../pages/private/candle-validations/CandleValidationsPage';
import CandleWorkersPage from '../pages/private/candle-workers/CandleWorkersPage';
import PairPage from '../pages/private/pair/PairPage';
import PairsPage from '../pages/private/pairs/PairsPage';
import StrategiesPage from '../pages/private/strategies/StrategiesPage';
import StrategyPage from '../pages/private/strategy/StrategyPage';
import ButtonPage from '../pages/public/buttons/ButtonPage';
import CalendarPage from '../pages/public/calendar/CalendarPage';
import ChipsPage from '../pages/public/chips/ChipsPage';
import CreateAccountPage from '../pages/public/create-account/CreateAccountPage';
import DropdownPage from '../pages/public/dropdown/DropdownPage';
import FrameworkPage from '../pages/public/framework/FrameworkPage';
import LoginPage from '../pages/public/login/LoginPage';
import PasswordRequestPage from '../pages/public/password-request/PasswordRequestPage';
import PasswordResetPage from '../pages/public/password-reset/PasswordResetPage';
import AuthTemplate from '../templates/AuthTemplate';
import PrivateTemplate from '../templates/PrivateTemplate';
import PublicTemplate from '../templates/PublicTemplate';

export const PUBLIC = {
  ROOT: {
    path: '/',
    element: lazyLoad(PublicTemplate),
  },
  FRAMEWORK: {
    path: '/framework',
    element: lazyLoad(FrameworkPage),
  },
  BUTTONS: {
    path: '/button',
    element: lazyLoad(ButtonPage),
  },
  SELECTS: {
    path: '/dropdown',
    element: lazyLoad(DropdownPage),
  },
  CALENDAR: {
    path: '/calendar',
    element: lazyLoad(CalendarPage),
  },
  CHIPS: {
    path: '/chips',
    element: lazyLoad(ChipsPage),
  },
  LOGIN: {
    path: '/login',
    element: lazyLoad(LoginPage),
  },
  PASSWORD_REQUEST: {
    path: '/request-password',
    element: lazyLoad(PasswordRequestPage),
  },
  PASSWORD_RESET: {
    path: '/reset-password/:code',
    element: lazyLoad(PasswordResetPage),
  },
  CREATE_ACCOUNT: {
    path: '/create-account',
    element: lazyLoad(CreateAccountPage),
  },
};

export const AUTH = {
  ROOT: {
    path: '/auth',
    element: lazyLoad(AuthTemplate),
  },
  EMAIL: {
    path: '/auth/email',
    element: lazyLoad(VerifyEmailPage),
  },
  TWO_FACTOR: {
    path: '/auth/two-factor',
    element: lazyLoad(ApplicationPage),
  },
};

export const PRIVATE = {
  ROOT: {
    path: '/',
    element: lazyLoad(PrivateTemplate),
  },

  APPLICATION: {
    path: '/application',
    element: lazyLoad(ApplicationPage),
  },
  PAIRS: {
    path: '/application/pairs',
    element: lazyLoad(PairsPage),
  },
  BACKTESTS: {
    path: '/application/backtests',
    element: lazyLoad(BacktestsPage),
  },
  STRATEGIES: {
    path: '/application/strategies',
    element: lazyLoad(StrategiesPage),
  },
  STRATEGY: {
    path: '/application/strategies/:strategy_id',
    element: lazyLoad(StrategyPage),
  },
  CANDLE_WORKERS: {
    path: '/application/candle-workers',
    element: lazyLoad(CandleWorkersPage),
  },
  CANDLE_VALIDATIONS: {
    path: '/application/candle-validations',
    element: lazyLoad(CandleValidationsPage),
  },
  PAIR: {
    path: '/application/pairs/:pair_id',
    element: lazyLoad(PairPage),
  },
  '404': {
    path: '*',
    element: lazyLoad(ErrorPage),
  },
};
